import * as API from '@/services/API'

export default {
    relateContact({commit, dispatch, rootGetters}, payload){
        return API.apiClient.post('/properties/' + rootGetters['properties/property'].id + '/contacts', payload)
            .then((response) => {
                commit('SET_CURRENT_CONTACT', {})
                return dispatch('getContacts')
            })
            .catch(error => {
                commit('SET_ERROR', error, { root: true })
            })
    },

    getContacts({commit, rootGetters}, propertyId) {
        if(!propertyId){
            propertyId = rootGetters['properties/property'].id 
        }
        API.apiClient.get('/properties/' + propertyId + '/contacts')
            .then((response) => {
                commit('SET_CONTACT_LIST', response.data)
            })
            .catch((error) => {
                commit('SET_ERROR', error, {root: true})
            })
    },

    unlink({commit, dispatch, rootGetters}, id) {
        return API.apiClient.delete('/properties/' + rootGetters['properties/property'].id + '/contacts/' + id)
            .then((response) => {
                return dispatch('getContacts')
            })
            .catch((error) => {
                commit('SET_ERROR', error, {root: true})
            })
    }

}